import styled from '@emotion/styled';
import { Typography } from '@kc-console/common-ui';
import { useServiceAppState } from '@kc-console/context';
import { useTranslation } from '@kc-console/core';

import { useMegaMenuState, useRefinedConsoleMenuState, useSearchedMenus } from '../../../../hooks';
import SearchResultMenuItem from './SearchResultMenuItem';

interface Props {
  inputValue: string;
}

const SearchResults = ({ inputValue }: Props) => {
  const { t } = useTranslation();
  const { allServices } = useRefinedConsoleMenuState();
  const { activeCategory, isAllCategory } = useMegaMenuState();

  const {
    state: { region },
  } = useServiceAppState();

  const subTitle = isAllCategory
    ? t('layout:search.result.region_all', { region })
    : t('layout:search.result.region_category', { region, category: activeCategory });

  const searchedMenus = useSearchedMenus(allServices, inputValue, activeCategory);

  return (
    <SearchResultContainer>
      <SearchResultSubTitle variant={'label/semibold/xs'}>{subTitle}</SearchResultSubTitle>
      <OptionItemListContainer>
        {searchedMenus.length > 0 &&
          searchedMenus.map(menu => (
            <SearchResultMenuItem key={menu.name} menu={menu} keyword={inputValue} />
          ))}
        {searchedMenus.length === 0 && (
          <NoSearchResultText variant={'label/regular/md'}>
            {t('layout:search.result.no_result', { keyword: inputValue })}
          </NoSearchResultText>
        )}
      </OptionItemListContainer>
    </SearchResultContainer>
  );
};

const SearchResultContainer = styled.div`
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

const SearchResultSubTitle = styled(Typography)`
  padding: 7px 12px;
  margin-bottom: 4px;
  color: #878e9b;
`;

const NoSearchResultText = styled(Typography)`
  padding: 13.5px 12px;
  color: #878e9b;
`;

const OptionItemListContainer = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export default SearchResults;
